import {CookieManager,COOKIE_NAMES} from './CookieManager'

export class Popup {

    /**
     * @param {Date} dateStart
     * @param {Date} dateEnd
     */
    constructor(dateStart,dateEnd) {
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }

    isPopupVisible() {
        const today = new Date();
        var dateEndStatus = true;
        if (null !== this.dateEnd) {
            dateEndStatus = today < this.dateEnd;
        }
        return this.dateStart < today && dateEndStatus;
    }

    /**
     * @param {int} popupId
     */
    showPopup(popupId) {
        let popupBox = document.querySelector('.popup-text');
        let popupSite = document.querySelector('#popup-site');

        if (null != popupBox) {
            popupSite.style.display = 'inline-block';

            popupBox.addEventListener("click", (event) => {

                this.hidePopup();

                CookieManager.setCookie(COOKIE_NAMES.popup, popupId, 1);
                return false;

            }, false);
        }
    }

    hidePopup() {
        let popupSite = document.querySelector('#popup-site');
        if (null != popupSite) {
            popupSite.style.display = 'none';
        }
    }

}
